// import { useEffect } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUserStore } from "../../../store";
import Text from "../Text";
import Button from "../Button";
import styles from "./ErrorMessage.module.css";

const ErrorMessage = ({
  error,
  contentName,
}: {
  error: any;
  contentName: string;
}) => {
  const theme = useUserStore((state) => state.theme);

  return (
    <div className={styles.component}>
      <FontAwesomeIcon
        icon={faExclamationTriangle as IconProp}
        id={styles[`${theme}Icon`]}
      />
      <Text variant="Body1" color="White">
        API Error Loading Content
      </Text>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
};

export default ErrorMessage;
